(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vd-quick-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vd-quick-extras')) {
  customElements.define('vd-quick-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('.vd-extras__submit');
      if (!this.button) return;
      this.status = this.querySelector('.vd-extras__status');
      this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
      this.money = new Intl.NumberFormat(this.dataset.locale || 'nl', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.querySelectorAll('[data-use-filter]').forEach(button => button.addEventListener('click', () => {
        const selected = button.dataset.useFilter;
        this.querySelectorAll('[data-use-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        let removed = false;
        this.querySelectorAll('[data-use]').forEach(row => {
          row.hidden = selected !== 'all' && row.dataset.use !== 'both' && row.dataset.use !== selected;
          if (row.hidden && row.querySelector('input').checked) { removed = true; row.querySelector('input').checked = false; }
        });
        if (removed) this.status.textContent = this.dataset.filterReset;
        this.update();
      }));
      this.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    update() {
      const selected = this.inputs.filter(input => input.checked);
      this.button.disabled = this.busy || !selected.length;
      if (!this.busy) this.button.textContent = selected.length ? `${this.dataset.add} (${selected.length}) · ${this.money.format(selected.reduce((sum,input) => sum + Number(input.dataset.price),0)/100)}` : this.dataset.empty;
    }
    async add() {
      const selected = this.inputs.filter(input => input.checked);
      if (this.busy || !selected.length) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.inputs.forEach(input => input.disabled = true);
      this.status.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:selected.map(input => ({id:input.value,quantity:1}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        this.status.textContent = `${this.dataset.success} ${selected.map(input => input.dataset.title).join(', ')}.`;
        selected.forEach(input => input.checked = false);
        this.querySelector('.vd-extras__cart').hidden = false;
        document.dispatchEvent(new CustomEvent('vd:cart-refresh',{detail:{open:false}}));
      } catch (error) {
        this.status.textContent = `${this.dataset.error} ${error.message || ''}`;
        this.querySelector('.vd-extras__cart').hidden = false;
        document.dispatchEvent(new CustomEvent('vd:cart-refresh',{detail:{open:false}}));
      } finally {
        this.busy = false;
        this.inputs.forEach(input => input.disabled = false);
        this.update();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vd59-cover-collection"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealMeasure = () => {
    const measure = document.getElementById('vd59-cover-measure');
    if (measure && window.location.hash === '#vd59-cover-measure') measure.open = true;
  };
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href="#vd59-cover-measure"]') : null;
    const measure = document.getElementById('vd59-cover-measure');
    if (!link || !measure) return;
    event.preventDefault();
    measure.open = true;
    if (window.location.hash !== '#vd59-cover-measure') {
      window.history.pushState(null, '', '#vd59-cover-measure');
    }
    measure.scrollIntoView({ block: 'start' });
    measure.querySelector('summary')?.focus({ preventScroll: true });
  });
  window.addEventListener('hashchange', revealMeasure);
  revealMeasure();
})();
  } catch(e) { console.error(e); }
})();

})();
